import { storage } from '@visiba/std';

export const applicationSessionStorage = storage<{
	showAlias: boolean;
	hideGatewayOnMobileFriendly: boolean;
}>({ type: 'session' });
